import './CreateUserProfile.css';
import React, {useState} from "react";
import AddPillar from  './AddPillar.js'
import AddProject from './AddProject.js'

import { generateClient } from "aws-amplify/api";
import { createUserProfile } from '../../../graphql/mutations';
const client = generateClient()

function CreateUserProfile () {
    const [userName, setUserName] = useState("")
    const [pillars, setPillars] = useState([]);
    const [projects, setProjects] = useState([]);

    function clearFormData() {
      setUserName("");
      setPillars([]);
      setProjects([]);
    }

    const handleNameChange = (event) => {
        setUserName(event.target.value);
      };

    const addUserProfile = async () => {
        try {
          const userProfile = { ...{
            "name": userName,
            "pillars": pillars,
            "projects": projects,
            "morningRoutineSteps": [],
            "eveningRoutineSteps": []
          } };
          await client.graphql({
            query: createUserProfile,
            variables: {
              input: userProfile
            },
            authMode: 'userPool'
          });
          console.log("user profile uploaded")
          clearFormData()
        } catch (err) {
          console.log('error creating user profile', err);
        }
      }


    return (
        <div className="createUserProfile">
          <p className="createUserProfileWelcome"> welcome to one of fourteen! </p>
          <p className="createUserProfileDescriptiveText"> let's get the basics of your account set up. everything is editable later on! </p>
          <p className="createUserProfileDescriptiveText"> if you want to learn more about us before creating your account, <a className="href" href="/landing"> click here!</a> </p>
            <div className="createUserProfileSetName">
                <p className="createUserProfileSetNameHeader">enter your name</p>
                <textarea
                    className="createUserProfileNameInput"
                    type="text"
                    id="userName"
                    value={userName}
                    onChange={handleNameChange}
                    name="userName"
                    spellCheck="false"
                />
            </div>
            <div className="userProfileGroup">
                <p className="createUserProfileDescriptiveText">your pillars are what supports you and your goals. Things like your health, your friends and family, your passion for your work. <a target="_blank" rel="noopener noreferrer" className="href" href="/story/pillars"> if you want to read more, you can here! </a></p>
                {pillars.map((pillar, index) => (
                    <p key={index} className="createUserProfileSetNameHeader"> pillar #{index+1}: {pillar.title}, {pillar.glowPercent}% glow </p>
                ))}
                <AddPillar pushChanges={false} pillars={pillars} setPillars={setPillars}/>
            </div>
            <div className="userProfileGroup">
                <p className="createUserProfileDescriptiveText">your projects are the specific comprehensive topics that you work on. for example, if you're a student, each of your classes would be a project. <a target="_blank" rel="noopener noreferrer" className="href" href="/story/projects"> if you want to read more, you can here! </a></p>
                {projects.map((project, index) => (
                  <div key={index}>
                      <p> {project.title} {project.shortName} {project.backgroundColor}</p>
                    </div>
                ))}
                <AddProject pushChanges={false} projects={projects} setProjects={setProjects}/>
            </div>
            <p onClick={async () => {addUserProfile()} } className="addUserProfileButton"> save user profile</p>
        </div>
    )
}

export default CreateUserProfile;